var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calendar-footer",style:({
    paddingTop: _vm.height+'px',
  })},[_c('div',{ref:"content",staticClass:"calendar-footer__content"},[_c('FavouriteTogglerRow',{attrs:{"menu_id":_vm.menu_id}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }